import React from 'react';
import './Footer.css';

const Footer = () => {
  // Products data for footer
  const products = [
    {
      id: 1,
      name: 'HEMA-CORDIAL',
      category: 'womens-health'
    },
    {
      id: 2,
      name: 'GASSO-WIN',
      category: 'digestive-health'
    },
    {
      id: 3,
      name: 'VITAL COMPOUND',
      category: 'liver-health'
    },
    {
      id: 4,
      name: 'COUGH-CO',
      category: 'respiratory-care'
    },
    {
      id: 5,
      name: 'LIVWIN',
      category: 'liver-health'
    },
    {
      id: 6,
      name: 'ACHE-WIN OIL',
      category: 'pain-relief'
    },
    {
      id: 7,
      name: 'VITAL DROPS (Pediatric)',
      category: 'pediatric-care'
    },
    {
      id: 8,
      name: 'DYLOWIN TABLET',
      category: 'diabetes-care'
    }
  ];

  const handleProductClick = (productId) => {
    window.location.href = `/product/${productId}`;
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
            <div className="footer-section">
              <div className="footer-logo">
                <img src="/photos/SAP logo dark new.png" alt="Shiv Ayurvedic Pharmacy Logo" />
                <h3>Shiv Ayurvedic Pharmacy</h3>
              </div>
            <p className="footer-description">Authentic Ayurvedic wellness products crafted with ancient wisdom and modern science since 1965.</p>
            <div className="social-links">
              <a target='_blank' href="https://www.instagram.com/shivayurvedicpharmacy" aria-label="Instagram">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
              </a>
              <a target='_blank' href="mailto:shivayurvedicpharmacy@gmail.com" aria-label="Email">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 8L12 13L4 8V6L12 11L20 6V8Z"/>
                </svg>
              </a>
            </div>
          </div>
            
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul className="footer-links">
              <li><a href="/about.html">About Us</a></li>
              <li><a href="/products.html">Products</a></li>
              <li><a href="/contact.html">Contact</a></li>
              {/* <li><a href="#">Blog</a></li> */}
            </ul>
          </div>
            
          <div className="footer-section">
            <h4>Our Products</h4>
            <ul className="footer-links">
                {/* Previous Categories - Commented Out
                <li><a href="#womens-health">Women's Health</a></li>
                <li><a href="#digestive-health">Digestive Health</a></li>
                <li><a href="#respiratory-care">Respiratory Care</a></li>
                <li><a href="#liver-health">Liver Health</a></li>
                <li><a href="#pain-relief">Pain Relief</a></li>
                <li><a href="#pediatric-care">Pediatric Care</a></li>
                <li><a href="#diabetes-care">Diabetes Care</a></li>
                */}

                {/* Product Items */}
                {products.map((product) => (
                  <li key={product.id}>
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        handleProductClick(product.id);
                      }}
                    >
                      {product.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            
          <div className="footer-section">
            <h4>Customer Care</h4>
            <ul className="footer-links">
              {/* <li><a href="#">Shipping Info</a></li>
              <li><a href="#">Returns</a></li> */}
              <li><a href="/contact.html">FAQ</a></li>
              <li><a href="/contact.html">Support</a></li>
            </ul>
          </div>
            
        </div>

        <div className="footer-bottom">
          <p>&copy; 2025 Shiv Ayurvedic Pharmacy. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;